import styled from 'styled-components';

export const StyledLabel = styled.label`
  display: block;
  font-size: 15px;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;
